export const language: any ={
  LabelFavorites: "즐겨찾기",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe: `아직 즐겨찾기한 요리가 없습니다.<br/>마음에 드는 요리를 추가해보세요!`,
  LabelDoYouWantUnSave: `해당 레시피를 저장 해지 하시겠습니까?`,
  save: '저장',
  unsave: '저장',
  OkFavorite: "예",
  CloseFavorite: "아니요",
}

